import { AgentState } from './types';

export const initialState: AgentState = {
  width: window.innerWidth,
  height: window.innerHeight,
  touch: 'ontouchstart' in window || !!navigator.maxTouchPoints,
  headerHeight: null,
};
